/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Unlink_Description_WhatsappInputs */

const he_account_delivery_unlink_description_whatsapp = /** @type {(inputs: Account_Delivery_Unlink_Description_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא תקבל יותר התראות דרך WhatsApp. תוכל לקשר מחדש בכל עת.`)
};

const en_account_delivery_unlink_description_whatsapp = /** @type {(inputs: Account_Delivery_Unlink_Description_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will no longer receive notifications via WhatsApp. You can re-link at any time.`)
};

/**
* | output |
* | --- |
* | "You will no longer receive notifications via WhatsApp. You can re-link at any time." |
*
* @param {Account_Delivery_Unlink_Description_WhatsappInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_unlink_description_whatsapp = /** @type {((inputs?: Account_Delivery_Unlink_Description_WhatsappInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Unlink_Description_WhatsappInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_unlink_description_whatsapp(inputs)
	return en_account_delivery_unlink_description_whatsapp(inputs)
});